module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#FAF9F5"
    }
  }, [_c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "blog-list-item",
    on: {
      "click": function($event) {
        return _vm.goTo('1')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-item",
    on: {
      "click": function($event) {
        return _vm.goTo('2')
      }
    }
  }, [_vm._m(2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog-top-box"
  }, [_c('div', {
    staticClass: "blog-top-box-content"
  }, [_c('div', {
    staticClass: "container blog-top-box-content-tit"
  }, [_c('h1', [_vm._v("News")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/blog/png1.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row blog-list-item-box"
  }, [_c('div', {
    staticClass: "col-lg-2 blog-list-item-box-lf"
  }, [_c('div', {
    staticClass: "blog-list-item-box-lf-tit"
  }, [_vm._v("December")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-item-box-lf-day"
  }, [_vm._v("24")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 blog-list-item-box-mid"
  }, [_c('h1', [_vm._v("Suzhou Campus holds the inaugural Suzhou Forum...")]), _vm._v(" "), _c('p', [_vm._v("\n                  The inaugural Suzhou Forum on Humanistic Economics and the unveiling ceremony of the Suzhou Research\n                  Center for Humanistic Economics of Renmin University of China was held at the Suzhou campus on December\n                  24, 2023.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 blog-list-item-box-rt"
  }, [_c('div', [_vm._v("2023-12-24")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row blog-list-item-box"
  }, [_c('div', {
    staticClass: "col-lg-2 blog-list-item-box-lf"
  }, [_c('div', {
    staticClass: "blog-list-item-box-lf-tit"
  }, [_vm._v("November")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-item-box-lf-day"
  }, [_vm._v("20")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 blog-list-item-box-mid"
  }, [_c('h1', [_vm._v("Suzhou Campus holds the Tenth Policy Forum in Asia")]), _vm._v(" "), _c('p', [_vm._v("\n                  The Tenth Policy Forum in Asia was held at Suzhou Campus, with the theme: challenges and governance in\n                  the digital age. Zhang Donggang, Chair of the University Council, Zheng Xinye, Vice President, as well\n                  as Satoshi Nakano, President and Dun Yamada, Vice President of Ichibashi University, attended the forum.\n                  Scholars from the two universities gave keynote speeches from different perspectives on opportunities and\n                  challenges brought by digital transformation, conducting discussions on new trends of scientific research and\n                  technological innovation in the digital age, changes in folk beliefs, local intangible cultural heritage customs\n                  related to water, international governance of e-commerce, the American Industrial Chain Alliance, characteristics\n                  of artificial intelligence and trust between human and machine.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 blog-list-item-box-rt"
  }, [_c('div', [_vm._v("2023-11-20")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637880f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BlogHome.vue
// module id = 73
// module chunks = 0